import type { AppButtonProps } from "../../AppButton/next";
import { useAppButtonState } from "../../AppButton/next";

import { useButton_unstable } from "@fluentui/react-components";
import {
  useAppComponentTooltips,
  useV9TooltipEnabled,
} from "@1js/acui-tooltip";

export const useAppSplitButtonPrimaryButton = (
  props: AppButtonProps,
  ref: React.Ref<HTMLButtonElement>
) => {
  const { disabled, customTooltip, tooltipDirection } = props;

  // Remove ID so it doesn't get added as an attribute on the HTML button
  const { id, ...propsWithoutId } = props;
  const v9TooltipEnabled = useV9TooltipEnabled();

  let finalRef = ref;
  if (!v9TooltipEnabled) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    finalRef = useAppComponentTooltips(ref, {
      ...props,
      direction: tooltipDirection,
    }).mergedRef;
  }

  // if customTooltip is passed in as a prop, attach a tooltip to the ref, otherwise use the default ref
  const primaryButtonRef = customTooltip ? finalRef : ref;

  // 'type' override here needed so that our types (e.g. "AppButtonProps") aren't assigned to the HTML element
  const state = useButton_unstable(
    { ...propsWithoutId, type: "button", disabledFocusable: disabled },
    primaryButtonRef
  );

  return useAppButtonState(props, state);
};
